var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryside1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 59,
    viewBox: "0 0 128 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60963 23.0266L5.31142 17.0398C3.1877 14.0817 3.25052 10.0822 5.4661 7.19232C8.11408 3.73843 12.987 2.93024 16.6082 5.34438L24.1935 10.4012C24.6432 10.701 24.9679 11.1548 25.1065 11.6772C27.358 20.1637 39.5622 19.6785 41.1328 11.04L41.4482 9.30554C41.7811 7.47427 43.8689 6.56995 45.4325 7.57974L57.8562 15.6034C61.6022 18.0227 66.427 17.9876 70.1374 15.5139C72.3189 14.0596 75.2422 14.4595 76.953 16.4462L77.3338 16.8884C83.3521 23.8774 94.7263 21.3779 97.2601 12.5097C97.8968 10.2815 99.8421 8.67723 102.151 8.47648L105.121 8.21818C109.75 7.81566 113.312 12.2318 111.938 16.6705C110.176 22.3638 112.663 28.5109 117.889 31.3765L122.229 33.757C123.938 34.6939 125 36.4875 125 38.4361V44.1233C125 46.5242 122.163 47.798 120.369 46.203C117.019 43.2255 111.965 43.2478 108.642 46.2545L107.26 47.5044C105.409 49.1791 102.591 49.1791 100.74 47.5044L100.438 47.2315C96.5182 43.6851 90.6647 43.3269 86.3418 46.3689L84.6835 47.5359C81.9157 49.4836 78.2109 49.4371 75.4929 47.4205L73.4378 45.8957C68.1429 41.9673 61.0816 41.3715 55.2034 44.3573L36.1884 54.0157C33.683 55.2883 30.885 55.8743 28.0795 55.7139L18.9504 55.1923C11.5123 54.7672 7.06074 46.7302 10.6462 40.1994C13.6364 34.7531 13.2332 28.0737 9.60963 23.0266Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryside1);
export default __webpack_public_path__ + "static/media/countryside1.c1e54da1.svg";
export { ForwardRef as ReactComponent };